import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Nav from "../Nav";
import { Link } from "react-router-dom";
import axios from "axios";
import Logout from "../logout/Logout";
import { useLocation } from "react-router-dom";
import { baseUrl, liveRateUrl } from "../constant.js";
import Theme from "../Theme";
import Modal from "react-modal";
//import "./Markettrade.css"
Modal.setAppElement("#root");

const Markettrade = () => {
  const customStyles = {
    content: {
      width: "200px",
      height: "150px",
      margin: "auto",
      border: "1px solid #ccc",
    },
  };
  const { state } = useLocation();
  console.log(state.token);
  const [lotSize, setLotsize] = useState(1);
  const [isactive, setActive] = useState(1);
  const [price, setPrice] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [response, setResponse] = useState("");
  const [err, setError] = useState("");
  const [status, setStatus] = useState("");
  const [BuyPrice, setBuyPrice] = useState();
  const [SellPrice, setSellPrice] = useState();
  const [LTP, setLTP] = useState();
  const [Open, setOpen] = useState();
  const [Close, setClose] = useState();
  const [Volume, setVolume] = useState();
  const [High, setHigh] = useState();
  const [Low, setLow] = useState();
  const [Change, setChange] = useState();
  const [Buyers, setBuyers] = useState();
  const [Seller, setSeller] = useState();
  const [OpenInterest, setOpenInterest] = useState();
  const [UpperCircuit, setUpperCircuit] = useState();
  const [LowerCircuit, setLowerCircuit] = useState();
  const [ATP, setATP] = useState();
  const [LastBuy, setLastBuy] = useState();
  const [LastSell, setLastSell] = useState();
  const [BidType, setBidType] = useState();
  const [lotlive, setLotsizelive] = useState();
  const [openint, setopenint] = useState();
  const [pricechange, setpeicechange] = useState();
  const navigate = useNavigate();
  console.log(BuyPrice);

  const CatLivedata = async () => {
    const id = localStorage.getItem("users");
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Token", token);
    formData.append("catToken", state.token);

    const liverate = await axios.post(liveRateUrl, formData);

    setBuyPrice(liverate.data.livedata[0].BuyPrice);
    setSellPrice(liverate.data.livedata[0].SellPrice);
    setLTP(liverate.data.livedata[0].LastTradePrice);
    setOpen(liverate.data.livedata[0].Open);
    setClose(liverate.data.livedata[0].Close);
    setVolume(liverate.data.livedata[0].TotalQtyTraded);
    setHigh(liverate.data.livedata[0].High);
    setLow(liverate.data.livedata[0].Low);
    setChange(liverate.data.livedata[0].PriceChangePercentage);
    setBuyers(liverate.data.livedata[0].BuyQty);
    setSeller(liverate.data.livedata[0].SellQty);
    setOpenInterest(liverate.data.livedata[0].OpenInterestChange);
    setUpperCircuit(liverate.data.livedata[0].UpperCircuit);
    setLowerCircuit(liverate.data.livedata[0].LowerCircuit);
    setATP(liverate.data.livedata[0].AverageTradedPrice);
    setLastBuy(liverate.data.livedata[0].BuyQty);
    setLastSell(liverate.data.livedata[0].SellQty);
    setLotsizelive(liverate.data.livedata[0].QuotationLot);
    setopenint(liverate.data.livedata[0].OpenInterest);
    setpeicechange(liverate.data.livedata[0].PriceChange.toFixed(2));
    CatLivedata();
  };

  useEffect(() => {
    const auth = localStorage.getItem("token");
    if (!auth) {
      navigate("/login");
    }
    CatLivedata();
    // const live=setInterval(()=>{
    //   CatLivedata()}, 100)
  }, []);
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    navigate("/trades");
  };
  const closeModal2 = () => {
    setIsOpen(false);
  };
  const selectLimit = () => {
    setActive(2);
    setError("");
  };
  const marketlimit = () => {
    setActive(1);
    setError("");
  };
  const marketsl = () => {
    setActive(3);
    setError("");
  };
  const buyhandel = async (btnType) => {
    const lot = state.QuotationLot;
    const expary = state.exparydate;
    const catid = state.catid;

    const tokenheader = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Token", tokenheader);
    formData.append("catID", catid);
    formData.append("exipreDate", expary);
    formData.append("orderType", isactive);
    formData.append("bidType", btnType);
    formData.append("lotSize", lotSize);
    if (btnType === 1) {
      formData.append("bidPrice", BuyPrice);
    } else {
      formData.append("bidPrice", SellPrice);
    }
    const result = await axios.post(
      baseUrl + `authController/orderAuth`,
      formData,
    );

    setResponse(result.data.message);
    setStatus(result.data.status);
    openModal();
  };

  const buyhande2 = async () => {
    const lot = state.QuotationLot;
    const expary = state.exparydate;
    const catid = state.catid;

    const tokenheader = localStorage.getItem("token");
    const id = localStorage.getItem("users");
    const head1 = {
      Token: `${tokenheader}`,
    };
    const bidtype = 1;
    console.log(bidtype);
    const formData = new FormData();
    formData.append("Token", tokenheader);
    formData.append("catID", catid);
    formData.append("exipreDate", expary);
    formData.append("orderType", isactive);
    formData.append("bidType", bidtype);
    formData.append("lotSize", lotSize);
    formData.append("bidPrice", price);

    if (price === " ") {
      setError(1);
    } else {
      const result = await axios.post(
        baseUrl + `authController/orderAuth`,
        formData,
      );

      setResponse(result.data.message);
      setStatus(result.data.status);
      openModal();
      setError("");
    }
  };
  const sellhande2 = async () => {
    const expary = state.exparydate;
    const catid = state.catid;
    const tokenheader = localStorage.getItem("token");

    const lot = state.QuotationLot;
    const bidtype = 2;

    const formData = new FormData();
    formData.append("Token", tokenheader);
    formData.append("catID", catid);
    formData.append("exipreDate", expary);
    formData.append("orderType", isactive);
    formData.append("bidType", bidtype);
    formData.append("lotSize", lotSize);
    formData.append("bidPrice", price);
    console.log(catid);
    console.log(tokenheader);
    console.log(expary);
    console.log(isactive);
    console.log(lot);
    console.log(price);

    if (price === " ") {
      setError(1);
    } else {
      const result = await axios.post(
        baseUrl + `authController/orderAuth`,
        formData,
      );
      console.log(result);
      setResponse(result.data.message);
      setStatus(result.data.status);
      openModal();
      setError("");
    }
  };

  return (
    <>
      <section className="marketwatch_pg online_trade_view">
        <div className="list_market_row text-center">
          <div className="onine_view_col">
            <div className="phone_frame">
              <div className="frame_screen">
                <div className="screen_body main_screenUI">
                  <div className="dashboard_main">
                    <div className="dashboard_header">
                      <div>
                        <Link to="/">
                          <i className="fa fa-angle-left"></i>
                        </Link>
                      </div>

                      <div>
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#color_modal"
                        >
                          <img
                            src="assets/img/icons/colour.png"
                            className="img-fluid color_icons"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="market_tab_col">
                      <div className="tab-content dashboard_col_tabs">
                        <div className="market_trades_colm market_colm_lg">
                          <h3>
                            {state.name}_{state.exparydate}
                          </h3>
                          <div className="market_tab_box">
                            <div className="select_tab_btn">
                              <div
                                class="btn-group"
                                role="group"
                                aria-label="Basic example"
                                style={{ height: "20px" }}
                              >
                                <button
                                  type="button"
                                  className={
                                    isactive === 1
                                      ? "btn btn-secondary active"
                                      : "btn btn-secondary"
                                  }
                                  style={{ width: "70px" }}
                                  onClick={marketlimit}
                                >
                                  Market
                                </button>
                                <button
                                  type="button"
                                  className={
                                    isactive === 2
                                      ? "btn btn-secondary active"
                                      : "btn btn-secondary"
                                  }
                                  style={{ width: "70px" }}
                                  onClick={selectLimit}
                                >
                                  Limit
                                </button>
                                <button
                                  type="button"
                                  className={
                                    isactive === 3
                                      ? "btn btn-secondary active"
                                      : "btn btn-secondary"
                                  }
                                  style={{ width: "70px" }}
                                  onClick={marketsl}
                                >
                                  SL
                                </button>
                              </div>
                            </div>

                            {status === 1 && (
                              <Modal
                                isOpen={isOpen}
                                onRequestClose={closeModal2}
                                style={customStyles}
                              >
                                <img
                                  src="assets/img/icons/checked.png"
                                  className="img-fluid color_icons"
                                />
                                <h2>Order Detail</h2>
                                <p>{response}</p>
                                <button onClick={closeModal}>Ok</button>
                              </Modal>
                            )}
                            {status === 0 && (
                              <Modal
                                isOpen={isOpen}
                                onRequestClose={closeModal2}
                                style={customStyles}
                              >
                                <img
                                  src="assets/img/icons/failed.png"
                                  className="img-fluid color_icons"
                                />
                                <h2>Order Detail</h2>
                                <p>{response}</p>
                                <button onClick={closeModal}>Ok</button>
                              </Modal>
                            )}
                          </div>
                          <div className="mcx_bid_section">
                            <h6>Enter the lots you want to buy:</h6>
                            <input
                              type="text"
                              name="lots"
                              className="form-control"
                              placeholder="1"
                              onChange={(e) => setLotsize(e.target.value)}
                            />
                            {isactive === 2 && <h6>Enter the price:</h6>}
                            {isactive === 3 && <h6>Enter the price:</h6>}
                            {isactive === 2 && (
                              <input
                                type="text"
                                name="price"
                                className="form-control"
                                style={{ marginTop: "5px" }}
                                placeholder=""
                                onChange={(e) => setPrice(e.target.value)}
                              />
                            )}

                            {isactive === 3 && (
                              <input
                                type="text"
                                name="price"
                                className="form-control"
                                style={{ marginTop: "5px" }}
                                placeholder=""
                                onChange={(e) => setPrice(e.target.value)}
                              />
                            )}
                            {err === 1 && (
                              <span style={{ color: "black" }}>
                                {" "}
                                price require
                              </span>
                            )}
                            {err === 1 && (
                              <span style={{ color: "black" }}>
                                require price
                              </span>
                            )}
                            <div>
                              <div
                                className="mcx_Sell_Btn"
                                style={{
                                  display: "flex",
                                  marginTop: "5px",
                                }}
                              >
                                {isactive === 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-login"
                                    style={{ backgroundColor: "red" }}
                                    onClick={() => buyhandel(2)}
                                  >
                                    Sell @ {BuyPrice}{" "}
                                  </button>
                                )}
                                {isactive === 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-login"
                                    style={{ backgroundColor: "green" }}
                                    onClick={() => buyhandel(1)}
                                  >
                                    Buy @ {SellPrice}{" "}
                                  </button>
                                )}
                                {isactive === 2 && (
                                  <button
                                    type="button"
                                    className="btn btn-login"
                                    style={{ backgroundColor: "red" }}
                                    onClick={() => sellhande2()}
                                  >
                                    Sell @ {price}
                                  </button>
                                )}
                                {isactive === 2 && (
                                  <button
                                    type="button"
                                    className="btn btn-login"
                                    style={{ backgroundColor: "green" }}
                                    onClick={() => buyhande2()}
                                  >
                                    Buy @ {price}
                                  </button>
                                )}
                                {isactive === 3 && (
                                  <button
                                    type="button"
                                    className="btn btn-login"
                                    style={{ backgroundColor: "red" }}
                                    onClick={() => sellhande2()}
                                  >
                                    sell @ {price}
                                  </button>
                                )}
                                {isactive === 3 && (
                                  <button
                                    type="button"
                                    className="btn btn-login"
                                    style={{ backgroundColor: "green" }}
                                    onClick={() => buyhande2()}
                                  >
                                    Buy @ {price}
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="market_bid_details Market_lg">
                          <div className="bid_tables">
                            <table className="table align-middle mb-0 bg-white">
                              <tbody>
                                <tr>
                                  <td>
                                    Bid <span> {BuyPrice}</span>
                                  </td>
                                  <td>
                                    Ask <span>{SellPrice}</span>
                                  </td>
                                  <td>
                                    Last P <span>{LTP}</span>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    Open<span>{Open}</span>
                                  </td>
                                  <td>
                                    Close<span>{Close}</span>
                                  </td>
                                  <td>
                                    Volume<span>{Volume}</span>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    High<span>{High}</span>
                                  </td>
                                  <td>
                                    Low<span>{Low}</span>
                                  </td>
                                  <td>
                                    Change
                                    <span>{pricechange}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Buyers<span>{Buyers}</span>
                                  </td>
                                  <td>
                                    Seller<span>{Seller}</span>
                                  </td>
                                  <td>
                                    Open Interest<span>{openint}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Upper CKT<span>{UpperCircuit}</span>
                                  </td>
                                  <td>
                                    Lower CKT<span>{LowerCircuit}</span>
                                  </td>
                                  <td>
                                    ATP<span>{ATP}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Last Buy<span>{LastBuy}</span>
                                  </td>
                                  <td>
                                    Last Sell<span>{LastSell}</span>
                                  </td>
                                  <td>
                                    Lot Size<span>{lotlive}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Theme />
                    <Nav />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Markettrade;
